import React, { useMemo, useState, useEffect } from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { GatsbyImageProps } from "gatsby-image"

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"

import Layout from "../components/common/Layout"
import SEO from "../components/common/Seo"
import ScrollableColumn from "../components/pages/home/ScrollableColumn"
import WaitingScreen from "../components/pages/home/WaitingScreen"

import { IProject, ITheme } from "../types/project"
import { IPodcastContentful } from "../types/podcast"
import { ITwitterStatus, IInstaPost } from "../types/social"

import { projectFilters } from "../services/filtersList"
import { socialList } from "../services/socialList"

const projectViews = ["index", "galerie"]

const StyledRow = styled(Row)`
  position: relative;
  overflow: hidden;
`

type DataProps = {
  site: {
    buildTime: string
    siteMetadata: {
      logo: string
    }
  }
  allContentfulProjects: {
    nodes: IProject[]
  }
  contentfulGlobalContent: {
    waitingIntro?: {
      childContentfulRichText: {
        html?: string
      }
    }
    waitingImage?: GatsbyImageProps
    projectsTheme1?: string
    projectsTheme2?: string
    projectsTheme3?: string
    projectsTheme4?: string
  }
  allTweets: {
    nodes: ITwitterStatus[]
  }
  // allContentfulPodcasts: {
  //   nodes: IPodcastContentful[]
  // }
  // INSTA POSTS
  // allInstagramContent: {
  //   nodes: IInstaPost[]
  // }
}

interface IProps {
  data: DataProps
  path: string
}

const IndexPage = ({ data, path }: IProps) => {
  const twitterStatuses = data.allTweets?.nodes || null
  // const instaNode = data.allInstagramContent?.nodes || null
  // const podcasts = data.allContentfulPodcasts?.nodes || null

  const { nodes: projectsData } = data.allContentfulProjects
  const { logo } = data.site.siteMetadata

  const {
    waitingIntro,
    waitingImage,
    projectsTheme1,
    projectsTheme2,
    projectsTheme3,
    projectsTheme4,
  } = data.contentfulGlobalContent
  const intro1 = waitingIntro?.childContentfulRichText.html

  const projects = projectsData.sort(
    (a: IProject, b: IProject) => b.order - a.order
  )

  const themes: ITheme[] = [
    { id: 0, label: "sol", text: projectsTheme1 },
    { id: 1, label: "ressource", text: projectsTheme4 },
    { id: 2, label: "amo", text: projectsTheme3 },
    { id: 3, label: "activation", text: projectsTheme2 },
  ]

  /**
   * Handle waiting screen
   */
  const [isIntro, setIsIntro] = useState<boolean>(true)

  // Store in session storage
  const sessionFirstView =
    typeof window !== "undefined" &&
    sessionStorage.getItem("sessionFirstView")

  const closeIntro = (): void => {
    typeof window !== "undefined" &&
      sessionStorage.setItem("sessionFirstView", "false")
    setIsIntro(false)
  }

  const params =
    typeof window !== "undefined" && document.location.search

  const isEventsActive = useMemo(
    () => params === "?que-pense-georges",
    [params]
  )

  return (
    <>
      <Layout id="mainWrapper">
        <SEO title="Home" />
        <Container fluid>
          <StyledRow id="popinWrapper">
            <ScrollableColumn
              id="projects-column"
              title="que fait georges ?"
              type="projects"
              content={projects}
              views={projectViews}
              themes={themes}
              filters={projectFilters(projects)}
              isEventsActive={isEventsActive}
            />
            {/* <ScrollableColumn
              id="events-column"
              title="que pense georges ?"
              type="events"
              content={socialList({
                twitterStatuses,
                // instaNode,
                podcasts,
              })}
              isEventsActive={isEventsActive}
            /> */}
          </StyledRow>
        </Container>
      </Layout>
      {waitingImage &&
        intro1 &&
        sessionFirstView !== "false" &&
        isIntro && (
          <WaitingScreen
            image={waitingImage}
            intro1={intro1}
            logo={logo}
            closeIntro={closeIntro}
          />
        )}
    </>
  )
}

export default IndexPage

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
      siteMetadata {
        logo
      }
    }
    contentfulGlobalContent(name: { eq: "globalContent" }) {
      waitingIntro {
        childContentfulRichText {
          html
        }
      }
      waitingImage {
        fluid(maxWidth: 1920) {
          aspectRatio
          src
          srcSet
          sizes
          ...GatsbyContentfulFluid
        }
      }
      projectsTheme1
      projectsTheme2
      projectsTheme3
      projectsTheme4
    }
    allContentfulProjects {
      totalCount
      nodes {
        id
        contentful_id
        name
        order
        createdAt
        updatedAt
        shortname
        cover {
          fluid(maxWidth: 900) {
            aspectRatio
            src
            srcSet
            sizes
            ...GatsbyContentfulFluid
          }
        }
        cardView
        focus
        theme
        role
        date
        region
        city
        department
        mission {
          mission
        }
        surface
        partners
        constructionProject
        amount
        teamGeorges {
          firstName
          name
        }
        introduction {
          introduction
        }
        photos {
          id
          title
          fluid(maxWidth: 1920) {
            aspectRatio
            src
            srcSet
            sizes
            ...GatsbyContentfulFluid
          }
        }
      }
    }
    # INSTA POSTS
    # allInstagramContent {
    #   nodes {
    #     caption
    #     id
    #     media_id
    #     media_type
    #     media_url
    #     permalink
    #     timestamp
    #     username
    #   }
    # }
    # allTweets: allTwitterStatusesUserTimelineAtelierGeorges {
    #   # totalCount
    #   nodes {
    #     created_at
    #     full_text
    #     id
    #     id_str
    #     is_quote_status
    #     possibly_sensitive
    #     source
    #     # user {
    #     #   id
    #     #   name
    #     #   screen_name
    #     #   url
    #     # }
    #     display_text_range
    #     entities {
    #       hashtags {
    #         indices
    #         text
    #       }
    #       media {
    #         display_url
    #         url
    #         expanded_url
    #         id
    #         media_url
    #         media_url_https
    #         type
    #         indices
    #       }
    #       urls {
    #         display_url
    #         indices
    #         expanded_url
    #         url
    #       }
    #     }
    #   }
    # }
    # allContentfulPodcasts {
    #   totalCount
    #   nodes {
    #     id
    #     name
    #     url
    #     date
    #     completeDate
    #     type
    #     description {
    #       childContentfulRichText {
    #         html
    #       }
    #     }
    #     playlist {
    #       id
    #       name
    #     }
    #     cover {
    #       fluid(maxWidth: 900) {
    #         aspectRatio
    #         src
    #         srcSet
    #         sizes
    #         ...GatsbyContentfulFluid
    #       }
    #     }
    #   }
    # }
  }
`
